// extracted by mini-css-extract-plugin
export default {"hidden":"hidden__avatarMenu__cdrks","menu":"menu__avatarMenu__FDyNO","menuItem":"menuItem__avatarMenu__Y9hw9"};